import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Input } from "Application";
import { StudentSessionBehaviourViewModel } from "./StudentSessionBehaviourViewModel";

export const StudentSessionBehaviourView: React.FC<{ viewModel: StudentSessionBehaviourViewModel }> = observer(({ viewModel }) => {
    return (
        <Box padding={"10px"}>
            <Input
                displayName="Score (1 to 10)"
                maxLength={2}
                type="number"
                min={1}
                max={10}
                isRequired
                value={() => viewModel.getValue("score")}
                command={viewModel.updateScoreCommand}
                onBlur={() => viewModel.onScoreBlurCommand.execute()}
                showClearText={false}
                validationMessage={() => viewModel.getError("score")}
            />
        </Box>
    );
});
